import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import type { DTOUserLanguageEntry } from 'src/apis/dto/DTOUserLanguageEntry';
import {
  useGetPreferredLanguagesQuery,
  useUpdatePreferredLanguagesMutation,
} from 'src/hooks/usePreferredLanguagesQuery';

const usePreferredLanguagesSelection = () => {
  const [draftSelectedPreferredLanguages, setDraftSelectedPreferredLanguagesBase] = useState<
    DTOUserLanguageEntry[] | null
  >(null);
  const setDraftSelectedPreferredLanguages: Dispatch<
    SetStateAction<NonNullable<typeof draftSelectedPreferredLanguages>>
  > = (value) => {
    return setDraftSelectedPreferredLanguagesBase(value as typeof draftSelectedPreferredLanguages);
  };
  const { data: preferredLanguagesData } = useGetPreferredLanguagesQuery();
  const { mutate } = useUpdatePreferredLanguagesMutation();

  const discardChanges = () => {
    setDraftSelectedPreferredLanguages(preferredLanguagesData?.data?.preferredLanguages ?? []);
  };

  const saveChanges = () => {
    mutate({
      preferredLanguages: draftSelectedPreferredLanguages || [],
    });
  };

  useEffect(() => {
    if (!preferredLanguagesData?.data) return;

    setDraftSelectedPreferredLanguages(preferredLanguagesData.data.preferredLanguages);
  }, [preferredLanguagesData?.data]);

  return {
    draftSelectedPreferredLanguages,
    setDraftSelectedPreferredLanguages,
    discardChanges,
    saveChanges,
  };
};

export default usePreferredLanguagesSelection;
